import { ReactNode } from 'react';
import { Redirect } from 'react-router-dom';
import useAuth from '../hooks/useAuth';

type GuestGuardProps = {
  children?: ReactNode;
};

const GuestGuard = ({ children }: GuestGuardProps) => {
  const { isAuthenticated, user } = useAuth();

  if (isAuthenticated && user?.verified) {
    if (user.userType === 'C') {
      return <Redirect to="/welcome" />;
    } else {
      if (!user?.account?.subscription?.status) {
        return (
          <Redirect
            to={{
              pathname: '/register',
              state: { case: 'payment', email: user.email },
            }}
          />
        );
      } else {
        if (['LiveOnly'].some((role) => user.groups.some((item) => item.name === role))) {
          return <Redirect to="/app/clients" />;
        }

        return <Redirect to="/app/dashboard" />;
      }
    }
  } else if (isAuthenticated && user?.verified === false) {
    return (
      <Redirect
        to={{
          pathname: user.userType === 'T' ? '/register' : '/onboard-client',
          state: { case: 'verify', email: user.email },
        }}
      />
    );
  }

  return <>{children}</>;
};

export default GuestGuard;
